import { useCallback, useState } from "react";
import { exportTriloChatPdfs } from "../utils/triloChatPdf";

/**
 * PDF export for the open MW conversation.
 *
 * @param {Object} options
 * @param {string|null} options.sessionId - Id of the open session
 * @param {Object|null} options.session - The open session (title, created_at)
 * @param {Array} options.messages - Conversation messages
 * @param {Object} options.draftStates - Draft decisions from useTriloChatDrafts
 * @returns {Object} { isExporting, exportConversation }
 */
export const useTriloChatExport = ({
  sessionId,
  session,
  messages,
  draftStates,
}) => {
  const [isExporting, setIsExporting] = useState(false);

  const exportConversation = useCallback(async () => {
    if (!sessionId || messages.length === 0 || isExporting) return;
    setIsExporting(true);
    try {
      await exportTriloChatPdfs({ session, messages, draftStates });
    } catch (e) {
      console.error("PDF export failed", e);
    } finally {
      setIsExporting(false);
    }
  }, [sessionId, session, messages, draftStates, isExporting]);

  return { isExporting, exportConversation };
};
